import { useRoutes } from 'react-router-dom';

import routes from './routes';

const AdminRoutes = () => {
    const element = useRoutes(routes);

    return <div>{element}</div>
}

export default AdminRoutes;
